import { FieldContext, FieldOptions, RuleExpression, useField } from 'vee-validate'
import { MaybeRef } from '@vueuse/core'
import { ref } from 'vue'

export function useFieldHelper<TValue = unknown>(
    name: MaybeRef<string> | undefined,
    rules?: MaybeRef<RuleExpression<TValue>>,
    opts?: Partial<FieldOptions<TValue>>
): FieldContext<TValue> {
    // default values to allow non-form-validation usage of input components wrapped in useForm() usage
    if (!name) {
        return {
            errorMessage: ref(null),
            handleChange: () => null,
        }
    }
    return useField(name, rules, opts)
}
